var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 24 24",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M22 11.08V12a10 10 0 1 1-5.93-9.14",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M22 4 12 14.01l-3-3",
  stroke: "currentColor",
  strokeWidth: 2,
  strokeLinecap: "round",
  strokeLinejoin: "round"
})));
export { SvgCheckCircle as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTIyIDExLjA4VjEyQzIxLjk5ODggMTQuMTU2NCAyMS4zMDA1IDE2LjI1NDcgMjAuMDA5MyAxNy45ODE4QzE4LjcxODIgMTkuNzA5IDE2LjkwMzMgMjAuOTcyNSAxNC44MzU0IDIxLjU4MzlDMTIuNzY3NCAyMi4xOTUzIDEwLjU1NzMgMjIuMTIxOSA4LjUzNDQ3IDIxLjM3NDZDNi41MTE2OCAyMC42MjczIDQuNzg0NjUgMTkuMjQ2MSAzLjYxMDk2IDE3LjQzNzFDMi40MzcyNyAxNS42MjggMS44Nzk3OSAxMy40ODgxIDIuMDIxNjggMTEuMzM2M0MyLjE2MzU2IDkuMTg0NTUgMi45OTcyMSA3LjEzNjMxIDQuMzk4MjggNS40OTcwNkM1Ljc5OTM1IDMuODU3ODEgNy42OTI3OSAyLjcxNTM3IDkuNzk2MTkgMi4yNDAxM0MxMS44OTk2IDEuNzY0OSAxNC4xMDAzIDEuOTgyMzIgMTYuMDcgMi44NTk5OSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS13aWR0aD0iMiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIi8+CjxwYXRoIGQ9Ik0yMiA0TDEyIDE0LjAxTDkgMTEuMDEiIHN0cm9rZT0iY3VycmVudENvbG9yIiBzdHJva2Utd2lkdGg9IjIiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIvPgo8L3N2Zz4K";